import dynamic from "next/dynamic";
import React from "react";
import {DrupalDocumentMedia, DrupalSearchApiResponseMeta} from "../../../types/hygiena-types";

const WidgetDocumentSearch = dynamic(() => import('../../organisms/widget--document-search').then((mod) => mod.WidgetDocumentSearch));

export function ParagraphSolrDocumentLibrary({paragraph, ...props}) {
  const documents: DrupalDocumentMedia[] = paragraph?.documents ?? [];
  const meta: DrupalSearchApiResponseMeta = paragraph?.documentSearchMeta ?? {};
  const prefilter: {path:string, value: string, operator: string}[] = [];

  if (paragraph?.field_sdl_categories?.length) {
    const categories = paragraph.field_sdl_categories.map(item => item?.resourceIdObjMeta?.drupal_internal__target_id);
    prefilter.push({path: 'field_document_categories', value: categories, operator: 'IN'});
  }
  if (paragraph?.field_sdl_technologies?.length) {
    const technologies = paragraph.field_sdl_technologies.map(item => item?.resourceIdObjMeta?.drupal_internal__target_id);
    prefilter.push({path: 'field_document_technology', value: technologies, operator: 'IN'});
  }

  const emptyFacets = meta?.facets?.filter(facet => !facet?.terms?.length) ?? [];
  const hideFacets: string[] = ["field_document_region", "name"];
  for (const facet of emptyFacets) {
    if (facet?.path) hideFacets.push(facet.path);
  }

  return (
    <div className="container px-4 md:px-0 pb-6 mx-auto mb-8">
      <WidgetDocumentSearch documents={documents} meta={meta} preFilter={prefilter}
                            hideFacets={hideFacets}/>
    </div>
)
}